import { Icon } from "@iconify/react";

function NavigateBar({ table }) {
  const pageCount = table.getPageCount();
  const canPreviousPage = table.getCanPreviousPage();
  const canNextPage = table.getCanNextPage();
  const currentPage = table.getState().pagination.pageIndex + 1;
  
  // Ne pas afficher la pagination si une seule page
  if (pageCount <= 1) {
    return null;
  }
  
  return (
    <div className="modern-pagination" style={{ 
      display: 'flex !important', 
      alignItems: 'center', 
      gap: '0.5rem', 
      marginTop: '2rem',
      marginBottom: '2rem',
      justifyContent: 'flex-end',
      padding: '1rem 0',
      clear: 'both',
      width: '100%'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        background: '#f8f9fa',
        padding: '0.5rem 1.5rem',
        borderRadius: '8px',
        border: '1px solid #e9ecef'
      }}>
        <span style={{ 
          color: '#6c757d', 
          fontSize: '0.9rem',
          fontWeight: 500
        }}>
          Page
        </span>
        <span style={{ 
          color: '#81c313',
          fontSize: '1rem',
          fontWeight: 'bold',
          minWidth: '20px',
          textAlign: 'center'
        }}>
          {currentPage}
        </span>
        <span style={{ 
          color: '#6c757d', 
          fontSize: '0.9rem'
        }}>
          /
        </span>
        <span style={{ 
          color: '#495057',
          fontSize: '0.9rem',
          fontWeight: 600
        }}>
          {pageCount}
        </span>

        <div style={{ width: '1px', height: '24px', background: '#dee2e6', margin: '0 0.5rem' }}></div>

        <button
          type="button"
          className="pagination-btn"
          style={{
            border: 'none',
            background: canPreviousPage ? 'white' : '#f8f9fa',
            cursor: canPreviousPage ? 'pointer' : 'not-allowed',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            transition: 'all 0.2s ease',
            opacity: canPreviousPage ? 1 : 0.4,
            minWidth: '36px',
            height: '36px'
          }}
          onClick={() => table.setPageIndex(0)}
          disabled={!canPreviousPage}
          aria-label="Première page"
          title="Première page"
        >
          <Icon icon="streamline:entertainment-control-button-previous-button-television-buttons-movies-skip-previous-video-controls" width={18} height={18} style={{ color: canPreviousPage ? '#81c313' : '#adb5bd' }} />
        </button>

        <button
          type="button"
          className="pagination-btn"
          style={{
            border: 'none',
            background: canPreviousPage ? 'white' : '#f8f9fa',
            cursor: canPreviousPage ? 'pointer' : 'not-allowed',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            transition: 'all 0.2s ease',
            opacity: canPreviousPage ? 1 : 0.4,
            minWidth: '36px',
            height: '36px'
          }}
          onClick={() => table.previousPage()}
          disabled={!canPreviousPage}
          aria-label="Page précédente"
          title="Précédent"
        >
          <Icon icon="material-symbols:arrow-back-ios-new-rounded" width={18} height={18} style={{ color: canPreviousPage ? '#81c313' : '#adb5bd' }} />
        </button>
        
        <button
          type="button"
          className="pagination-btn"
          style={{
            border: 'none',
            background: canNextPage ? 'white' : '#f8f9fa',
            cursor: canNextPage ? 'pointer' : 'not-allowed',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            transition: 'all 0.2s ease',
            opacity: canNextPage ? 1 : 0.4,
            minWidth: '36px',
            height: '36px'
          }}
          onClick={() => table.nextPage()}
          disabled={!canNextPage}
          aria-label="Page suivante"
          title="Suivant"
        >
          <Icon icon="material-symbols:arrow-forward-ios-rounded" width={18} height={18} style={{ color: canNextPage ? '#81c313' : '#adb5bd' }} />
        </button>
        
        <button
          type="button"
          className="pagination-btn"
          style={{
            border: 'none',
            background: canNextPage ? 'white' : '#f8f9fa',
            cursor: canNextPage ? 'pointer' : 'not-allowed',
            padding: '0.5rem',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '6px',
            transition: 'all 0.2s ease',
            opacity: canNextPage ? 1 : 0.4,
            minWidth: '36px',
            height: '36px'
          }}
          onClick={() => table.setPageIndex(pageCount - 1)}
          disabled={!canNextPage}
          aria-label="Dernière page"
          title="Dernière page"
        >
          <Icon icon="streamline:entertainment-control-button-next-button-television-buttons-movies-skip-next-video-controls" width={18} height={18} style={{ color: canNextPage ? '#81c313' : '#adb5bd' }} />
        </button>
      </div>
    </div>
  );
}

export default NavigateBar;
